import { render, staticRenderFns } from "./ApprovalHistory.vue?vue&type=template&id=d4f8b2fc&scoped=true"
import script from "./ApprovalHistory.vue?vue&type=script&lang=js"
export * from "./ApprovalHistory.vue?vue&type=script&lang=js"
import style0 from "./ApprovalHistory.vue?vue&type=style&index=0&id=d4f8b2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f8b2fc",
  null
  
)

export default component.exports